import React from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';

import { withLabels } from 'containers/withLabels';
import { getImageTechDocUrl } from 'components/ImageTechDoc';

import IconEye from 'media/icons/eye.icon.svg';
import styles from './DocumentItem.module.scss';
const cx = classNames.bind(styles);

const DocumentItem = ({ item, labels }) => (
  <div className={cx('row')}>
    <div className={cx('cell', 'cell-description')}>
      <h4 className={cx('title')}>
        <a
          href={getImageTechDocUrl(item.docId)}
          target="_blank"
          download
          className={cx('title-link')}
        >
          {item.docFileName}
        </a>
      </h4>
    </div>
    <div className={cx('cell', 'cell-btn')}>
      <a
        href={getImageTechDocUrl(item.docId)}
        target="_blank"
        download
        className={cx('link')}
      >
        <span className={cx('btn-icon')}>
          <IconEye />
        </span>
        <span className={cx('btn-text')}>{labels.buttonDiscoverLabel}</span>
      </a>
    </div>
  </div>
);

DocumentItem.propTypes = {
  item: object.isRequired,
  labels: object.isRequired,
};

export default withLabels(DocumentItem);



// WEBPACK FOOTER //
// ./src/pages/Product/components/TabResources/components/DocumentItem/DocumentItem.js